import type { SavedPaymentMethod } from '@/lib/stripeBillingService';
import type { ClientPortalPaymentMethodSummary } from './clientPortalFhirTypes';

export function formatCardBrand(brand: string): string {
  const b = brand.toLowerCase();
  if (b === 'visa') return 'Visa';
  if (b === 'mastercard') return 'Mastercard';
  if (b === 'amex' || b === 'american_express') return 'Amex';
  if (b === 'discover') return 'Discover';
  return brand || 'Card';
}

export function savedPaymentMethodToClientPortalSummary(
  pm: SavedPaymentMethod,
): ClientPortalPaymentMethodSummary {
  const brandLabel = formatCardBrand(pm.brand);
  return {
    id: pm.id,
    stripePaymentMethodId: pm.stripePaymentMethodId,
    type: 'card',
    brand: brandLabel,
    last4: pm.last4,
    label: `${brandLabel} ending in ${pm.last4}`,
    nickname: pm.nickname || undefined,
    isDefault: pm.isDefault,
    expMonth: pm.expMonth,
    expYear: pm.expYear,
  };
}
